/**
 * Logic Necessary for the Postings (Jobs/Classifieds)
 * List View
 * Author: Imarc 2020
 */

import classToggle from '@inkwell/scripts/modules/classtoggle';

// Executions
classToggle({});
